import { Link } from '@remix-run/react'
import { memo } from 'react'
import { Icon } from '../ui/icon.tsx'
import { cn } from '#app/utils/misc.tsx'

export interface IBreadcrumbItem {
	label: string
	href?: string
	active?: boolean
}

interface IBreadcrumbs {
	items: IBreadcrumbItem[]
	backItem: IBreadcrumbItem
}

const Breadcrumbs = ({ items, backItem }: IBreadcrumbs) => {
	if (items.length > 0) {
		backItem = items[items.length - 2]
	}

	return (
		<nav aria-label="breadcrumb" className={cn('breadcrumb mt-2')}>
			<Link
				to={backItem.href ?? ''}
				relative="path"
				className="breadcrumb-back !block"
			>
				<Icon name="chevron-left" />
				{backItem.label}
			</Link>
			<ol className="breadcrumb-list">
				{items?.map((item, index) => (
					<li
						key={item.label + (item.href ?? index.toString())}
						className={cn(
							'breadcrumb-item',
							index === items.length - 1 && 'active',
						)}
					>
						{index === items.length - 1 ? (
							item.label
						) : (
							<Link
								to={item.href ?? ''}
								relative="path"
								className="breadcrumb-item-link"
							>
								{item.label}
							</Link>
						)}
					</li>
				))}
			</ol>
		</nav>
	)
}

export default memo(Breadcrumbs)
